import React, { useContext, useState } from "react";
import { Col, Row, Icon, Switch } from 'antd';
import { UPDATE_USERINFO } from "../../../utils/query";
import { useForm } from "react-hook-form";
import FormLoading from '../../../components/common/loaders/formLoading';
import { AuthContext } from '../../../context/auth';
import { useMutation } from '@apollo/client';

export default function CompleteProfile() {
    const { login, user } = useContext(AuthContext);

    const { register, formState: { errors }, handleSubmit } = useForm();

    const [isCompany, setIsCompany] = useState(false);

    const [updateUser, { loading, error }] = useMutation(UPDATE_USERINFO, {
        onCompleted(userData) {
            console.log('result data : ' + JSON.stringify(userData));

            let newUserData = user;

            newUserData.user.full_name = userData.updateUsersPermissionsUser.data.attributes.full_name;
            newUserData.user.nation_code = userData.updateUsersPermissionsUser.data.attributes.nation_code;
            newUserData.user.is_company = userData.updateUsersPermissionsUser.data.attributes.is_company;
            newUserData.user.mobile_number = userData.updateUsersPermissionsUser.data.attributes.mobile_number;

            console.log(newUserData);

            login(newUserData);

            window.location.reload();

        },
        onError() {

        }
    });



    const onSubmit = formData => {
        updateUser({ variables: { id: parseInt(user.user.id), is_company: isCompany, full_name: formData.fullname, mobile_number: formData.mobilenumber, nation_code: formData.nationcode } });


    }

    return (
        <div>
            <p className={"normalText1"} style={{ textAlign: 'center' }}>تکمیل اطلاعات جهت استفاده از امکانات سامانه</p>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="quickOrderForm">
                    {error ? (
                        <p className={"inputFormRrrorText"} style={{ textAlign: 'center', marginBottom: 15 }}>
                            {error.graphQLErrors.map(({ message }, i) => {
                                return <span key={i}>{message}</span>
                            })}
                        </p>
                    ) : ''}
                    {
                        loading ? (
                            <FormLoading />
                        ) : (
                            <Row className="quickOrderFormRow">
                                <Col span={12}>
                                    <div className="formItem" style={{ alignItems: 'flex-end' }}>
                                        <Switch
                                            checkedChildren={<><Icon type="user" /><span>حقیقی</span></>}
                                            unCheckedChildren={<><Icon type="bank" /><span>حقوقی</span></>}
                                            defaultChecked
                                            onChange={() => setIsCompany(!isCompany)}
                                        />
                                    </div>
                                </Col>

                                <Col span={12}>
                                    <div className="formItem">
                                        <p style={{ textAlign: 'right', fontSize: 14 }}> : نوع حساب کاربری</p>
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="formItem">
                                        <p className={"formItemHelp"}>{isCompany ? 'نام شرکت' : 'نام و نام‌خانوادگی'}</p>
                                        <input
                                            className={"ant-input ant-input-lg"}
                                            type="text"
                                            {...register("fullname", { required: true, maxLength: 50, minLength: 5 })}
                                            placeholder={isCompany ? 'نام شرکت' : 'نام و نام‌خانوادگی'}
                                        />
                                        <p className={"inputFormRrrorText"}>
                                            {errors.fullname && errors.fullname.type === "required" && "این فیلد ضروری است"}
                                            {errors.fullname && errors.fullname.type === "minLength" && "حداقل ۵ کاراکتر لازم است"}
                                            {errors.fullname && errors.fullname.type === "maxLength" && "حداکثر ۵۰ کاراکتر مجاز است"}
                                        </p>
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="formItem">
                                        <p className={"formItemHelp"}>شماره موبایل</p>
                                        <input
                                            className={"ant-input ant-input-lg"}
                                            type="text"
                                            {...register("mobilenumber", { pattern: /^[0-9_]*$/, required: true, maxLength: 11, minLength: 11 })}
                                            placeholder='09121010110'
                                        />
                                        <p className={"inputFormRrrorText"}>
                                            {errors.mobilenumber && errors.mobilenumber.type === "pattern" && "فقط از اعداد انگلیسی استفاده کنید"}
                                            {errors.mobilenumber && errors.mobilenumber.type === "required" && "این فیلد ضروری است"}
                                            {errors.mobilenumber && errors.mobilenumber.type === "minLength" && "حداقل 11 کاراکتر لازم است"}
                                            {errors.mobilenumber && errors.mobilenumber.type === "maxLength" && "حداکثر 11 کاراکتر مجاز است"}
                                        </p>
                                    </div>
                                </Col>


                                <Col xs={24} md={12}>
                                    <div className="formItem">
                                        <p className={"formItemHelp"}>{isCompany ? 'شماره ثبت' : 'کد ملّی'}</p>
                                        <input
                                            className={"ant-input ant-input-lg"}
                                            type="text"
                                            {...register("nationcode", { pattern: /^[0-9_]*$/, required: true, maxLength: 14, minLength: 9 })}
                                            placeholder='0451122334'
                                        />
                                        <p className={"inputFormRrrorText"}>
                                            {errors.nationcode && errors.nationcode.type === "pattern" && "فقط از اعداد انگلیسی استفاده کنید"}
                                            {errors.nationcode && errors.nationcode.type === "required" && "این فیلد ضروری است"}
                                            {errors.nationcode && errors.nationcode.type === "minLength" && "حداقل 11 کاراکتر لازم است"}
                                            {errors.nationcode && errors.nationcode.type === "maxLength" && "حداکثر 11 کاراکتر مجاز است"}
                                        </p>
                                    </div>
                                </Col>

                                <Col span={24}>

                                    <div className={"formSubmitButton"}>
                                        <div className={"normalButtonWrapper darkBtn"}>
                                            <button type="submit" className={"normalButton loginButton"}>
                                                <div className="normalButtonInner">
                                                    <div style={{ marginRight: 7 }}>
                                                        <Icon type={'check-circle'} />
                                                    </div>
                                                    <p>ثبت اطلاعات</p>
                                                </div>
                                            </button>
                                        </div>

                                    </div>
                                </Col>


                            </Row>
                        )
                    }
                </div>
            </form>
        </div>
    )
}